export default __webpack_public_path__ + "static/media/flowbite-dropdown-quickship-page.48f809f8.svg";